export function leadAssistAuthUrl() {
    const baseUrl = process.env.VUE_APP_API_AUTH_URL;
    const clientId = process.env.VUE_APP_STRUCTURELY_CLIENT_ID;
    const redirectUri = process.env.VUE_APP_STRUCTURELY_REDIRECT_URI;
    const scope = process.env.VUE_APP_STRUCTURELY_SCOPE;
    const state = process.env.VUE_APP_STRUCTURELY_STATE;
    const responseType = 'code';

    return `${baseUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&state=${state}&response_type=${responseType}`;
};

export function getNextCampaignActionDate(regularTaskDate, recurringTaskDate) {
  if (!regularTaskDate && !recurringTaskDate) return null;
  const regularTask = regularTaskDate && new Date(regularTaskDate);
  const recurringTask = recurringTaskDate && new Date(recurringTaskDate);
  if (regularTask && recurringTask) {
    return regularTask < recurringTask ? regularTask : recurringTask;
  }
  return regularTask || recurringTask;
};
